import React, { useState } from "react";
import Loader from "../../Layout/Loader";
import { toast } from "react-toastify";
import { useAppContext } from "../../../AppContext";
import mainAxios from "../../../services/mainAxios";

import { useTranslation } from "react-i18next";
import invoiceStatuses from "../../../services/invoiceStatuses.json";
import TransportContent from "./TransportContent";
import { validateTransportInvoice } from "../../../services/data";


const CreateTransportInvoice = (props) => {
  const { t, i18n } = useTranslation("translations");
  const {
    user: [user],
    selectedCompany: [selectedCompany],
    unitsOfMeasure,
    unitOfmeasureLoading,
  } = useAppContext();

  const company = user.companiesRights.find(
    (company) => company.id === parseInt(selectedCompany)
  );


  const branch =
  company.branches.find((branch) => branch.default) || company.branches[0];
  let businessUnitCode = branch?.businUnitCode ?? "";
  let orderedTcrs = (branch?.tcrTypes
  ?.filter(
    (tcrType) =>
      tcrType.businUnitCode === businessUnitCode && tcrType?.allowInvoice &&  !(tcrType?.status < 100)
  )??[])
  .sort((a, b) => b.recordDate - a.recordDate);
  const tcrCode=orderedTcrs?.[0]?.tcrCode ?? ""



  const [errors, setErrors] = useState({});



  const seller = {
    sellerIDType: "NUIS",
    name: company.name,
    tin: company.nuis,
    address: branch.sellerAddress,
    country: branch.sellerCountry,
    town: branch.sellerTown,
  };
  const buyer = {
    name: "",
    tin: null,
    address: "",
    town: "",
    country: "Albania",
    buyerIDType: "NUIS",
  };

  const [pageState, setPageState] = useState({
    loading: false,
  });

  let unitsOfMeasureDefault = unitsOfMeasure?.find(unitsOfMeasure => unitsOfMeasure?.code === "C62") ?? null;

 

  const [state, setState] = useState({
    parties: {
      seller,
      buyer,
        transporter: {
          name: "",
          idType: "NUIS",
          address: "",
          town: "",
          country: "ALB",
          idNum: "",
        },
      },
      address: [
        {
          address: "",
          city: "",
          point: "WAREHOUSE",
          type: "start",
          date: new Date(),
        },
        {
          address: "",
          city: "",
          point: "OTHER",
          type: "destination",
          date: "",
        },
    ],
    type: "TI",
    transaction: "PROCESSING",
    issueDate: new Date(),
    operatorCode:
      user?.userCompanyOperator?.find(
        (companyOperator) => companyOperator.company === company.id
      )?.operator || null,
    businessUnitCode,
    tcrCode,
    goodsFammable: false,
    escortRequired: false,
    packType: "Boxes",
    packNum: "",
    valueOfGoods: "",
    internalId: "",
    subseq:"",
    vehicle: {
      vehicleOwnership: "OWNER",
      vehiclePlate: "",
    },
    items: [
      { 
        id: '1',
        code: "",
        name: "",
        unitOfMeasureId: unitsOfMeasureDefault ?? null,
        quantity: "",
    },
    ],
  });

  const handleSave = () => {
    
    const validateInvoiceFields = validateTransportInvoice({ setErrors, toast, state: state,t })
    const { vehicle: { vehiclePlate }, } = state;
      console.log({state,validateInvoiceFields})

    if (!state.items.length)  {
      toast.error("Items should be completed!", {
        containerId: "all_toast",
      });
      setPageState((setPageState) => ({
        ...setPageState,
        saving: false,
      }));
    } 
    if(!new RegExp(/^([a-zA-Z0-9-]+)$/).test(vehiclePlate)) {
      toast.error(t(["toast.incorrectPlate"]), { containerId: "all_toast" });
    }else{
      setPageState((setPageState) => ({
        ...setPageState,
        loading: false,
        saving: false,
      }));
    }
    if(validateInvoiceFields) return  
          
    if (state.parties.transporter.idType) state.parties.transporter.idType = state.parties.transporter.idType.trim();
    if (state.parties.transporter.name) state.parties.transporter.name = state.parties.transporter.name.trim();
    if (state.parties.seller.name) state.parties.seller.name = state.parties.seller.name.trim();
    if (state.internalId) state.internalId = state.internalId.trim();
    mainAxios.post("apiEndpoint/saveOrUpdate", {
          object: "CustomTI",
          content: {
            status: invoiceStatuses[0],
            ...state,
            itemsNum: state.items.length,
            items: state.items.map((item) => {
              const { id, ...rest } = item;
              return rest;
            }),
          },
          nuis: company.nuis.trim(),
        })
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(t(["toast.draftSaved"]), {
              containerId: "all_toast",
            });
            props.history.push("/edit-transport-invoice/" + res.data.content[0].id);
          }
          setPageState((setPageState) => ({
            ...setPageState,
            saving: false,
          }));
        })
        .catch(() => {
          setPageState((setPageState) => ({
            ...setPageState,
            saving: false,
          }));
        });

  };

  return !pageState.loading || !unitOfmeasureLoading ? (
    <div className="row  m-2 rounded">
      <div className={`${false ? "col-xl-10" : "col-xl-12"} col-12 mx-auto wizard-form`}>
        <TransportContent transportState={state} setErrors={setErrors} errors={errors} handleSave={handleSave} pageState={pageState} setTransportState={setState} canEdit={true} unitsOfMeasure={unitsOfMeasure} />
      </div>
    </div>
  ) : (
    <Loader />
  );

};

export default CreateTransportInvoice;
